import {FUIFormContext} from "./form-context";
import {Injectable} from "@angular/core";
import {FUIContextType} from "./form-context-type";

/**
 * Context for controls being used in a filter content-layout. In Fedelta applications this is typically in the header bar.
 * Filter controls are typically more basic that edit controls as they usually do not include some features such as
 * validation.
 */
@Injectable()
export class FUIFilterFormContext extends FUIFormContext {
    constructor() {
        super(FUIContextType.FILTER, "Filter");
    }
}
